import { format } from 'date-fns'
import PropTypes from 'prop-types'
import { useEffect, useState } from 'react'

import CustomerOrderLineItem from 'components/CustomerOrderLineItem'
import Text from 'components/Text'

import { Caret, CaretIcon, ExpandButton, ExpandButtonText, LineItems, Tr } from './CustomerOrder.style'
import CaretSvg from './svg/caret.svg'

const formatDate = (dateString) => {
  const date = new Date(dateString)
  return format(date, 'do MMMM yyyy')
}

const CustomerOrder = ({ order }) => {
  const [expanded, setExpanded] = useState(false)
  return (
    <>
      <Tr className="cursor-pointer" onClick={() => setExpanded(!expanded)}>
        <td>
          <span aria-hidden="true">
            <Text weight="semibold">Date</Text>
          </span>
          <Text>{formatDate(order.date)}</Text>
        </td>
        <td>
          <span aria-hidden="true">
            <Text weight="semibold">Order No.</Text>
          </span>
          <Text>{order.orderNumber}</Text>
        </td>
        <td>
          <span aria-hidden="true">
            <Text weight="semibold">Location</Text>
          </span>
          <Text>{order.channel}</Text>
        </td>
        <td>
          <span aria-hidden="true">
            <Text weight="semibold">Sales associate</Text>
          </span>
          <Text>{order.salesRepOrBuyer || '-'}</Text>
        </td>
        <td>
          <ExpandButton>
            <ExpandButtonText>
              <Text>View items</Text>
            </ExpandButtonText>
            <Caret $isOpen={expanded}>
              <CaretIcon $isOpen={expanded}>
                <CaretSvg width={12} height={7} />
              </CaretIcon>
            </Caret>
          </ExpandButton>
        </td>
      </Tr>
      {expanded && (
        <tr>
          <td colSpan="5">
            <LineItems>
              {order.dispatchers.map((dispatcher) => (
                <CustomerOrderLineItem key={dispatcher.id} lineItem={dispatcher} />
              ))}
            </LineItems>
          </td>
        </tr>
      )}
    </>
  )
}

CustomerOrder.propTypes = {
  order: PropTypes.object.isRequired,
}

CustomerOrder.defaultProps = {}

export default CustomerOrder
